import { Routes, Route, Outlet } from 'react-router-dom'
import ScreenWrapper from '../components/shared/ScreenWrapper'
import ChargerScreen from './ChargerScreen'
import MapScreen from './MapScreen'
import NoRouteFound from './NoRouteFound'
import ChargerStateProvider from '../state/ChargerStateProvider'
import { Helmet } from 'react-helmet'

function Layout() {

	return (
		<ScreenWrapper noFooter>
				<Helmet>
					<title>TezLab | Charger Map</title>
				</Helmet>
				<MapScreen />
				<ChargerStateProvider logIt={process.env.NODE_ENV === 'development'}>
					<Outlet />
				</ChargerStateProvider>
		</ScreenWrapper>
	)
}

export default function Root() {
	return (
		<Routes>
			<Route path='/' element={<Layout />}>
				<Route path='charger/:id' element={<ChargerScreen />} />
				<Route path='*' element={<NoRouteFound />} />
			</Route>
		</Routes>
	)
}
